
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { IconButton } from '@material-ui/core'
import * as transcriptViewerActions from '../../transcriptViewerActions'

import './SendToEmail.scss'

const SendToEmail = ({ transcriptId, trySendToEmail }) => (
  <div className="sendToEmail roundButton">
    <IconButton onClick={() => trySendToEmail(transcriptId)} />
  </div>
)

SendToEmail.propTypes = {
  transcriptId: PropTypes.string.isRequired,
  trySendToEmail: PropTypes.func.isRequired,
};

export default connect(
  state => ({
  }), dispatch => bindActionCreators({
    trySendToEmail: transcriptViewerActions.trySendToEmail,
  }, dispatch),
)(SendToEmail);
